import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const containerPadding = {
  padding: '97px 0 110px',

  [MediaQueries.md]: {
    paddingBottom: 112,
    paddingTop: 100,
  },

  [MediaQueries.lgAndUp]: {
    paddingBottom: 64,
    paddingTop: 100,
  },
};

export const containerSizes = {
  alignItems: 'flex-end',
  display: 'flex',
  maxHeight: 802,
  minHeight: `calc(100vh - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,

  [MediaQueries.md]: {
    maxHeight: 1104,
  },

  [MediaQueries.mdAndUp]: {
    minHeight: `calc(100vh - ${NAV_MAX_HEIGHT}px)`,
  },

  [MediaQueries.lgAndUp]: {
    maxHeight: 1272,
  },
};

export const heading = css(typography.effra119, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  margin: '0',
  marginBottom: 51,
  paddingRight: 30,
  position: 'relative',

  [MediaQueries.sm]: {
    'html[lang="ru"] &': {
      fontSize: '32px !important',
    },
  },

  [MediaQueries.md]: {
    marginBottom: 100,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 73,
  },

  'html[lang="ru"] &': {
    fontSize: 72,
  },
});

export const section = css(typography.effra16, {
  color: colorsPalette.red,
  fontWeights: fontWeights.regular,
  margin: 0,
});

export const subsection = css(
  {
    color: colorsPalette.grey80,
    fontWeights: fontWeights.regular,
    margin: 0,
    marginBottom: 26,

    [MediaQueries.md]: {
      marginBottom: 23,
    },

    [MediaQueries.lgAndUp]: {
      marginBottom: 0,
    },
  },
  typography.effra16,
);

export const descriptionLeft = css(typography.effra16, {
  color: colorsPalette.grey,
  fontWeights: fontWeights.regular,
  margin: 0,
  marginBottom: 30,

  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const descriptionRight = css(typography.effra16, {
  color: colorsPalette.grey,
  fontWeights: fontWeights.regular,

  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});
